import React from 'react';
import PropTypes from 'prop-types';
import { ButtonWithIcon } from '@els/els-react--button';
import QuickSearchAutosuggest from '@Containers/QuickSearchAutosuggest';
import useStaticExamplesEnabled from '@Pages/QuickSearch/Components/BuildQuery/useStaticExamplesEnabled';
import wrapWithStaticExamples from '@Pages/QuickSearch/Components/RxSearchLabel/wrapWithStaticExamples';
import RxSearchLabel from '../../RxSearchLabel';
import QuickSearchPromptInput from './QuickSearchPromptInput';

import './BuildQuerySearch.scss';
import SearchTips from '../SearchTips/SearchTips';

const QuickSearchAutosuggestWithStaticExamples = wrapWithStaticExamples(QuickSearchAutosuggest);

function BuildQuerySearch(props) {
  const {
    query,
    populateQuickSearch,
    updateInputText,
    searchByQuery,
    structurePreview,
    structureName,
    previewSize,
    goToStructure,
    clearStructure,
    showImportModal,
    isAIQuickSearchBannerDisabled,
    onExampleApplied,
    promptInputFocusTrigger,
  } = props;
  const isStaticExamplesEnabled = useStaticExamplesEnabled();
  const headingAccessory = isAIQuickSearchBannerDisabled ? (
    <SearchTips updateInputText={updateInputText} onExampleApplied={onExampleApplied} />
  ) : null;

  const customInputRenderer = ({ value, inputOnChange, handleSearch, inputProps, placeholder }) => (
    <QuickSearchPromptInput
      promptInputFocusTrigger={promptInputFocusTrigger}
      headingAccessory={headingAccessory}
      inputProps={inputProps}
      onChange={inputOnChange}
      onClearStructure={clearStructure}
      onDraw={goToStructure}
      onSearch={handleSearch}
      previewSize={previewSize}
      structureName={structureName}
      structurePreview={structurePreview}
      value={value}
      placeholder={placeholder}
    />
  );

  return (
    <div className="build-query-search">
      <div className="build-query-search__input">
        {isStaticExamplesEnabled ? (
          <QuickSearchAutosuggestWithStaticExamples
            customInputRenderer={customInputRenderer}
            inputValue={query.text}
            buildQuery={{ updateInputText, query }}
            onChange={updateInputText}
            onSearch={searchByQuery}
          />
        ) : (
          <QuickSearchAutosuggest
            customInputRenderer={customInputRenderer}
            inputValue={query.text}
            buildQuery={{ updateInputText, query }}
            onChange={updateInputText}
            onSearch={searchByQuery}
          />
        )}
      </div>
      <ButtonWithIcon
        className="build-query-search__import"
        data-e2e="import-button"
        onClick={showImportModal}
        sprite="Download"
        type="secondary"
        aria-label="Import batch query">
        Import
      </ButtonWithIcon>
      {!isStaticExamplesEnabled ? <RxSearchLabel onSuffixClick={populateQuickSearch} /> : null}
    </div>
  );
}

BuildQuerySearch.propTypes = {
  query: PropTypes.object,
  structurePreview: PropTypes.string,
  structureName: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({ name: PropTypes.string, isLinearFormula: PropTypes.bool })]),
  previewSize: PropTypes.object,
  populateQuickSearch: PropTypes.func.isRequired,
  updateInputText: PropTypes.func.isRequired,
  searchByQuery: PropTypes.func.isRequired,
  goToStructure: PropTypes.func.isRequired,
  clearStructure: PropTypes.func.isRequired,
  showImportModal: PropTypes.func.isRequired,
  isAIQuickSearchBannerDisabled: PropTypes.bool,
  onExampleApplied: PropTypes.func,
  promptInputFocusTrigger: PropTypes.number,
};

BuildQuerySearch.defaultProps = {
  onExampleApplied: () => {},
  promptInputFocusTrigger: 0,
};

export default BuildQuerySearch;
